import React, { useEffect, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import AdminSideBar from "./AdminSideBar";
import { uiRoutes } from "../../routes/ui/uiRoutes";
import { getUserToken } from "../../config/user";
import { useNavigate } from "react-router-dom";
import OverlayLoader from "../Common/OverlayLoader";
import { ToastContainer } from "react-toastify";
const AdminAppBody = ({ content, loading }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [tokenChecked, setTokenChecked] = useState(false);
  const navigate = useNavigate();
  const token = getUserToken();
  useEffect(() => {
    if (!token || token === "" || token === undefined) {
      // Delay navigation slightly to avoid navigating during render
      setTimeout(() => {
        // window.location.href = "/";
        return navigate(uiRoutes.website.home);
      }, 0);
    }
  }, [navigate]);
  const toggleSidebar = () => {
    if (window.innerWidth <= 576) {
      setMobileSidebarOpen((prev) => !prev);
    } else {
      setCollapsed((prev) => !prev);
    }
  };
  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };
  if (!token) {
    console.log(token);
    console.log("call token");
    return navigate(uiRoutes.website.home);
  }
  console.log(token);
  // if (!tokenChecked) return null; // Prevent rendering until token is checked
  return (
    <div className="d-flex">
      <OverlayLoader show={loading} />
        <ToastContainer/>

      {/* Desktop Sidebar */}
      <div
        className={`admin-sidebar bg-white border-end d-none d-sm-block ${
          collapsed ? "collapsed" : ""
        }`}
      >
        <AdminSideBar collapsed={collapsed} />
      </div>
      {/* Mobile Sidebar */}
      {mobileSidebarOpen && (
        <>
          <div className="mobile-sidebar animate-slide-in">
            <AdminSideBar collapsed={false} />
          </div>
          <div className="sidebar-backdrop" onClick={closeMobileSidebar} />
        </>
      )}
      {/* Main content area */}
      <div className="flex-grow-1 d-flex flex-column vh-100 overflow-hidden">
        <div className="sticky-top z-3">
          <AdminNavBar collapsed={collapsed} toggleSidebar={toggleSidebar} />
        </div>
        <div className="flex-grow-1 overflow-auto p-2 bg-light">{content}</div>
      </div>
    </div>
  );
};
export default AdminAppBody;